// extracted by mini-css-extract-plugin
export var menuBg = "layout-module--menuBg--79ae1";
export var menuBgRed = "layout-module--menuBgRed--0b399";
export var wrapper = "layout-module--wrapper--5ec98";